import ShareDeal from './ShareDeal';

export default ShareDeal;
